const prompts = [{
    id: 1,
    prompt: "Hey, I'm feeling so overwhelmed at the minute. Everything is going wrong.",
    responses:[
        "Hey, it's no big deal, you'll be fine!",
        "But your life is so easy!",
        "Hey, that sounds really tough. Do you wanna talk about it?"
    ]
}, {
    id: 2,
    prompt: "I've been feeling really down about myself and my school work. I can't do anything right.",
    responses: [
        "Some people have much bigger problems.",
        "Really? You look fine to me!",
        "I'm here for you. Is there anything I can do to help?"
    ]
}, {
    id: 3,
    prompt: "Thanks. It's helping just knowing I can talk to you about it.",
    responses: [
        "You'll feel better if you just get on with you life and ignore it.",
        "I think it's time you got over it now, it's not that bad!",
        "I'm glad you reached out. It's good to talk to someone about how you're feeling."
    ]
}]

export default prompts;


// WEBPACK FOOTER //
// ./src/components/Talk/data/index.js